import {ISearchRequestModel} from '@app/shared/models/search-request.model';
import {ISearchResponseModel} from '@app/shared/models/search-response.model';
import {createAction, props} from '@ngrx/store';

export enum SearchActions {
  Search = '[Search Component] Search',
  SearchSuccess = '[Search Effects] Search Success',
  SearchFailure = '[Search Effects] Search Failure',
  SearchError = '[Search Effects] Search Error',
  ResetSearch = '[Search Effects] Search Reset',
}

export const searchAction = createAction(SearchActions.Search, props<{request: ISearchRequestModel}>());
export const searchEffectSuccess = createAction(SearchActions.SearchSuccess, props<{response: ISearchResponseModel}>());
export const searchEffectFailure = createAction(SearchActions.SearchFailure, props<{reason: string}>());
export const searchEffectError = createAction(SearchActions.SearchError, props<{error: string}>());
export const resetSearch = createAction(SearchActions.ResetSearch);
